<template>
  <div class="chat-evaluate" v-if="page.vis" @click="close">
    <div class="chat-evaluate__panel" @click.stop="(e) => {}">
      <div class="chat-evaluate__panel-header flex flex-center">
        <div class="chat-evaluate__header-title">诚邀您对本次留言处理情况做出评价！</div>
      </div>
      <div class="chat-evaluate__panel-body">
        <div class="chat-evaluate__input flex flex-center">
          <el-rate :max="5" size="large" v-model="page.form.evaluateScore" text-color="#ff9900" />
        </div>
        <div class="chat-evaluate__input">
          <el-input
            type="textarea"
            :rows="5"
            v-model="page.form.evaluateContent"
            :maxlength="200"
            show-word-limit
            placeholder="请输入评价内容"
          />
        </div>
        <el-button v-loading="page.btnLoading" class="chat-evaluate__btn" type="primary" @click="confirm">
          提交评价
        </el-button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ElMessage } from 'element-plus'
import { defineExpose, reactive, getCurrentInstance } from 'vue'
const page = reactive({
  vis: false,
  btnLoading: false,
  form: {
    msgId: null,
    custId: null,
    evaluateScore: null,
    evaluateContent: ''
  }
})
const { proxy } = getCurrentInstance()
const emit = defineEmits(['change'])
const init = (data) => {
  page.vis = true
  page.form.custId = data.custId
  page.form.msgId = data.msgId
  page.form.evaluateScore = data.evaluateScore
  page.form.evaluateContent = data.evaluateContent
}
const close = () => {
  page.vis = false
  page.form = {
    evaluateScore: null,
    evaluateContent: ''
  }
}
const confirm = () => {
  if (!page.form.evaluateScore) {
    return ElMessage.error('请选择评分！')
  }
  page.btnLoading = true
  proxy.$http.post('/app/custClient/saveEvaluateLeaveMsg', page.form).then((res) => {
    if (res.code === 0) {
      ElMessage.success('评价成功！')
      emit('change', page.form)
      close()
    } else {
      ElMessage.error(res.msg)
    }
  })
  page.btnLoading = false
}
defineExpose({
  init
})
</script>

<style scoped lang="less">
.chat-evaluate {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99;
  &__panel {
    background-color: #ffffff;
    border-radius: 10px;
    width: 300px;
  }
  &__panel-header {
    padding: 0 10px;
    line-height: 62px;
    border-bottom: 1px solid #eee;
  }
  &__header-title {
    font-size: 12px;
    color: #444444;
    font-weight: 600;
  }
  &__panel-body {
    padding: 25px 10px;
  }
  &__input {
    display: flex;
    font-size: 14px;
    color: #666666;
    margin-bottom: 12px;
  }
  &__btn {
    width: 100%;
    border: none;
    background: #3571f0;
  }
  &__tags {
    margin: 0 12px 12px 0;
    cursor: pointer;
  }
}
</style>
